$(function(){
  refreshCheckoutBtn();
  cartJSEvent();
  masterPromo(false);
  updateCountdownTimer();
  updateContentPosition();
  handleContentScroll();
  initKeyFeatureMobileSlider();
  updateMobileCardPos();
  initCustomProductSlider();
  initMobileProductSlider();
  designMode();
  calculateProgress();
  calculateProgressGWP();
  onloadHideSizeVariant();

  if (location.href.includes('/products')) {
    initFlickityImageGallery();
    onloadSiblingsProducts();
  }
});

designMode = () => {
  if (Shopify.designMode) {
    $(document).on('shopify:section:load', function(event) {
      initCustomProductSlider();
      initMobileProductSlider();
    });
  }
}

refreshCheckoutBtn = () => {

  var myInterval = setInterval( function(){
    if ($('.checkout-buttons #update-cart').length > 0) {
      // console.log('refresh checkout btn');
      $('.checkout-buttons #update-cart').removeClass('aiod_checkout_clicked').addClass('aiod_cart_loaded').removeAttr('disabled');
      // clearInterval(myInterval);
    }
    $('.checkout-buttons #update-cart').addClass('aiod_cart_loaded');
  } , 5000);
}

//Start CartJS Function

cartJSEvent = () => {
  $(document).on('cart.requestComplete', function(event, cart) {
    console.log('cart updated');
    //document.documentElement.dispatchEvent(
    //new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false }));
    $('.jsc-page-loading').remove();

    var varID = $('.price-descriptors').find('form').find('input[name="id"]').val();
    jscUpdateCartDrawer(varID);
  });
  $(document).on('cart.requestStarted', function(event, cart) {
    if (location.href.includes('/cart')) {
      var $html = `<div class="jsc-page-loading">
                  <div class="jsc-spinner-container">
                    <div class="jsc-loading-text">Updating your cart...</div>
                  </div>
                </div>`;
      $('body').prepend($html);
    }
    console.log('updating cart');
  });
}

cartJSAddQuery = (vid, qty, obj, isOpenDrawer) => {
  // Cart js add item, success callback, error callback

  CartJS.addItem(vid, qty, obj,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
}

cartJSUpdateQuery = (vid, qty, obj, isOpenDrawer) => {
  // Cart js add item, success callback, error callback

  CartJS.updateItemById(vid, qty, obj,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {

      if (location.href.includes('/cart')) {
        //reload only the product details section in cart page
        //console.log('data.item_count',data.item_count);
        
        if (!data.item_count) { // if cart is empty do this
          $(".jsc-cart-container").load(location.href+" .jsc-cart-container>*","");
          // console.log('reload empty cart section');
        }
      }
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
}
//End CartJS Function

//Start Master Promo Function
masterPromo = (isDrawer) =>{
  /*
  setTimeout(function(){
  */
    gwpFunction(isDrawer);
    cartGift();
  /*
  },1000);
  */
}

//Start GWP promo
gwpFunction = (isOpenDrawer) =>{
  $.when($.getJSON('/cart.js', function(cart) {

  })).then(function(cart){
    var $gwpcart_product = {};
    var $addEle = $('.jsc-add-gwp');
    var $updateEle = $('.jsc-update-gwp');
    var $deleteEle = $('.jsc-remove-gwp');

    $gwpcart_product['_Promo'] = 'Free Gift';

    $addEle.each(function() {
      var $vid = parseInt($(this).val());
      var $qty = parseInt($(this).attr('data-qty'));

      $gwpcart_product['_Promo_no'] = $(this).attr('data-promo');

      console.log('test');

      cartJSAddQuery($vid, $qty, $gwpcart_product, isOpenDrawer);
    });

    $updateEle.each(function() {
      var $vid = $(this).val();
      var $qty = parseInt($(this).attr('data-qty'));

      $gwpcart_product['_Promo_no'] = $(this).attr('data-promo');

      cartJSUpdateQuery($vid, $qty, $gwpcart_product, isOpenDrawer);
    });

    $deleteEle.each(function() {
      var $vid = $(this).val();
      var $qty = 0;

      cartJSUpdateQuery($vid, $qty, {}, isOpenDrawer);
    });

  });
}
//End GWP promo
//Start GWP based on cart, product or collection promo
cartGift = () =>{
  addCartGift();
  removeCartGift();
}

addCartGift = () =>{
  var $elem = $('.jsc-cart-gift');
  $elem.each(function(){
  var $vid = parseInt($(this).val());
  var $obj = {};
  var $promoNo = $(this).attr('data-promo');
  var removeGift = sessionStorage.getItem("FreeGift");

  $obj['_Cart_Gift'] = $promoNo;
  $obj['_Cart_GWP'] = 'Free Gift';
  if ($elem.length > 0) {
    if (removeGift != 'Remove') {
      cartJSAddQuery($vid,1,$obj,true);
    }
  }
  });
}

removeCartGift = () =>{
  var $elem = $('.jsc-cart-gift-remove');
  $elem.each(function(){
  var $key = parseInt($(this).val());

  if ($elem.length > 0) {
    cartJSUpdateQuery($key, 0, {}, true);
  }
  });
}

removeFreeGift = (e,varID) =>{
  // this function is used to remove gwp item in cart using sessionStorare. the gwp can only be re-added when browser is restarted
  sessionStorage.setItem("FreeGift", "Remove");
  //console.log(varID);
  cartJSUpdateQuery(varID, 0);
}
//End GWP based on cart, product or collection promo

//start: hover grid
jscHoverGrid = (e) => {
  if ($(window).width() > 799) {
    $(e).find('.jsc-grid-size-container').removeClass('d-none');
  }
}
jscOuthoverGrid = (e) => {
  if ($(window).width() > 799) {
    $(e).find('.jsc-grid-size-container').addClass('d-none');
  }
}
//end: hover grid

jscCollFilter = (e) => {
  
  var $thisFilter = $(e).parents('.link-dropdown');
  var $otherFilter = $thisFilter.siblings('.link-dropdown');
  var $dropdownWidth = $(e).siblings('.link-dropdown__options').width();
  console.log($dropdownWidth);
  // setTimeout(function(){},500);
    $(e).css('width',$dropdownWidth);
  
  

  $otherFilter.each(function(){
    $(this).find('.link-dropdown__button').attr('aria-expanded','false'); // to allow 1 filter open at a time
    $(this).find('.link-dropdown__button').css('width','fit-content');
    // console.log($(this));
  });
}

//start: pdp atc
jscClickATC = () => {
  var $cartDrawerType = $('.jsc-cart-drawer-type').attr('data-drawer-type');
  var $cartType = $('.jsc-cart-drawer-type').attr('data-cart-type');
  //console.log('$cartDrawerType',$cartDrawerType,'$cartType',$cartType);

  if ($cartType == 'drawer') {
    if ($cartDrawerType == 'top-drawer') {
      setTimeout(function(){
        var $cart_drawer = $('#cart-summary-overlay');
        if ($cart_drawer.length > 0) {
          console.log('close cart drawer2');
          $cart_drawer.css({
            transform: 'translateY(-100%)',
            transition: 'transform ease-out 0.5s'
          });
          // $cart_drawer.remove();
        }
      },5000);
    } else {
      var pageUrl = window.location.href;
      var varID = pageUrl.split('variant=')[1];
      jscUpdateCartDrawer(varID);
      $('#cart-summary-overlay').css({
        display: 'none'
      })
    }
  }
  
  // setTimeout(function(){
  //   jscOpenCartDrawer();
  // },500);
}
jscCustomATC = (e) => {
  var varID = $('.price-descriptors').find('form').find('input[name="id"]').val();
  //console.log('add123 varID',varID);
  cartJSAddQuery(varID,1,{},true);
}
//end 

onloadSiblingsProducts = () => {
  var $prod_details = $('.jsc-prod-json-details').find('.jsc-each-prod-json');
  var $prod_sibs_container = $('.jsc-sibling-products-content');
  var $prod_sibs_grid = $prod_sibs_container.find('.jsc-each-colour-url');
  var $current_url = window.location.href;
  // console.log($current_url);

  $prod_details.each(function(){
    var $this_graphql = $(this).attr('data-graphql');
    // console.log($this_graphql);

        // Define your GraphQL query

        const graphqlQuery = `
        query {
          product(id: "` + $this_graphql + `") {
            id
            title
            handle
            variants(first: 10) {
              edges {
                node {
                  title
                }
              }
            }
            featuredImage {
              id
              src
            }
          }
        }
        `;
        
        // Set the endpoint URL
        const endpointUrl = 'https://foxwood-clothing.myshopify.com/api/2023-10/graphql.json';

        // Send the GraphQL request using jQuery
        $.ajax({
          url: endpointUrl,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': '8d93c93237708dffc053eb9c21c10ace', 
          },
          data: JSON.stringify({ query: graphqlQuery }),
          success: function(response) {
            // Handle the response here
            // console.log('Result',response);
            var prod_title = response.data.product.title;
            var prod_handle = response.data.product.handle;
            var prod_img = response.data.product.featuredImage.src;
            // var prod_url = 'https://www.foxwoodclothing.com.au/products/' + prod_handle;
            var prod_url = '/products/' + prod_handle;
            var variant_title = response.data.product.variants.edges[0].node.title;
            var variant_color = variant_title.split(" / ");
            var type_tab;
            var var_color = '';

            if (variant_color[0] !== undefined ) {
              var_color = variant_color[0];
            } else {
              var_color = '';
            }
            var color_handle = var_color.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

            if ($current_url.includes(color_handle) && var_color != '') {
              // console.log('active',color_handle);
              type_tab = 'jsc-active-col';
            } else {
              // console.log('inactive',color_handle);
              type_tab = 'jsc-inactive-col';
            }
            // console.log(type_tab,color_handle);
            
            var $color_grid = '<a href="' + prod_url + '" class="jsc-each-colour-url"><div class="jsc-each-colour-prod ' + type_tab + '"><img class="jsc-each-colour-prod-img" src="' + prod_img + '" alt="' + prod_title +'"></div><span>' + var_color + '</span></a>';
            // console.log($color_grid);
            // $prod_sibs_container.append($color_grid);

            $prod_sibs_grid.each(function(){
              var $thisGraphql = $(this).attr('data-graphql');
              var $thisUrl;
              var $thisColor = $(this).find('span');
              var $thisColorImg = $(this).find('.jsc-each-colour-prod-img');             

              if ($thisGraphql == $this_graphql) {
                // console.log($color_grid);
                $thisUrl = $(this).attr("href",prod_url);
                $thisColor.text(var_color);
                $thisColorImg.attr("src",prod_img);
                $thisColorImg.attr("alt",prod_title);
                
                $(this).addClass(type_tab);
                $(this).removeClass('d-none');
                
              }
            });
          },
          error: function(error) {
            // Handle any errors here
            console.error('Error!',error);
          }
        });
  });


  
}

jscSelectVariant = (e) => {
  setTimeout(function(){
    var $label = $(e).siblings('.jsc-pdp-variant-label').find('.jsc-pdp-size');
    var $selected_size = $(e).find('li .active').attr('data-value');
    $label.find('.jsc-selected-variant').text($selected_size);
    
    var $var_unavailable = $(e).find('li .active').hasClass('unavailable');

    if ($var_unavailable == true) {
      // console.log('add oos');
      $('.jsc-buy-buttons-row').addClass('jsc-oos-button');
      $('.jsc-multiple-var-klaviyo.klaviyo-bis-trigger.d-none').removeClass('d-none');
    } else {
      // console.log('remove oos');
      $('.jsc-buy-buttons-row').removeClass('jsc-oos-button');
      $('.jsc-multiple-var-klaviyo.klaviyo-bis-trigger').addClass('d-none');
    }
    // console.log($var_available);
  },200)
  
}

// start: countdown timer
updateCountdownTimer = () => {
  var $countdownTimer = $('.jsc-countdown-timer-container .jsc-countdown-timer');
  if($countdownTimer.length > 0) {
    $countdownTimer.each(function() {
      var intervalID = setInterval(() => {
        var targetTime = new Date($(this).attr('data-end-date'));
        var timeZoneOffset = parseInt($(this).attr('data-timezone-offset').replace('+', '').slice(0, -2));
        var now = new Date();
        var nowOffset = now.getTimezoneOffset();
        var timeZoneOffsetMin = timeZoneOffset * 60;
        var offsetDiff = timeZoneOffsetMin + nowOffset;
        var localNowDate = new Date(now.getTime() + offsetDiff * 60000);
        var timeRemaining = targetTime - localNowDate;
  
        if (timeRemaining <= 0) {
          clearInterval(intervalID);
          var isHideOnEnd = $(this).attr('data-hide-on-end');
          if (isHideOnEnd == 'true') {
            $(this).removeClass('active');
          }
          $(this).siblings('.jsc-timer-end-text').addClass('active');
          return;
        }
  
        var days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
        var hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
  
        $(this).find('.jsc-timer-day').text(addLeadingZero(days));
        $(this).find('.jsc-timer-hour').text(addLeadingZero(hours));
        $(this).find('.jsc-timer-minute').text(addLeadingZero(minutes));
        $(this).find('.jsc-timer-second').text(addLeadingZero(seconds));      
      }, 1000);
    });
  }
}

addLeadingZero = (number) => {
  return number < 10 ? '0' + number : number;
}
// end: countdown timer

// start: key feature
updateContentPosition = () => {
  var $keyFeatureWrapper = $('.jsc-key-feature-wrapper');
  if($keyFeatureWrapper.length > 0) {
    var $firstMedia = $keyFeatureWrapper.find('.jsc-img-col .jsc-key-feature-media-item[data-index="1"] .jsc-media-box');
    var mediaHeight = $firstMedia.height();
    var $currentContent = $keyFeatureWrapper.find('.jsc-key-feature-content-list .jsc-key-feature-content-item.active');
    var contentHeight = $currentContent.height();

    var paddingTop = (mediaHeight / 2) - (contentHeight / 2);
    $currentContent.css('padding-top', paddingTop + 'px');
  }
}

handleContentScroll = () => {
  if($(window).width() > 798) {
    var $keyFeatureWrapper = $('.jsc-key-feature-wrapper');
    if($keyFeatureWrapper.length > 0) {
      var $mediaList = $keyFeatureWrapper.find('.jsc-img-col .jsc-key-feature-media-item .jsc-media-box');

      $(window).on('scroll', function() {
        $($mediaList).each(function() {
          if($(this).hasClass('active')) {
            var currentIndex = parseInt($(this).parent().attr('data-index'));
            var elementOffset = $(this).offset().top;
            var scrollTop = $(window).scrollTop();
            var distance = elementOffset - scrollTop;

            // activate next slide
            if(distance < 70) { 
              var nextIndex = currentIndex + 1;
              var $nextMedia = $(this).parent().siblings('.jsc-key-feature-media-item[data-index="' + nextIndex + '"]');
              if($nextMedia.length > 0) {
                var $currentBg = $keyFeatureWrapper.find('.jsc-key-feature-bg[data-index="' + currentIndex + '"]');
                var $nextBg = $keyFeatureWrapper.find('.jsc-key-feature-bg[data-index="' + nextIndex + '"]');
                var $currentContent = $keyFeatureWrapper.find('.jsc-key-feature-content-list .jsc-key-feature-content-item[data-index="' + currentIndex + '"]');
                var $nextContent = $keyFeatureWrapper.find('.jsc-key-feature-content-list .jsc-key-feature-content-item[data-index="' + nextIndex + '"]');

                $nextMedia.find('.jsc-media-box').addClass('active');
                $(this).removeClass('active');
                $nextBg.addClass('active');
                $currentBg.removeClass('active');
                $nextContent.addClass('active');
                $currentContent.removeClass('active');
                updateContentPosition();
              }
            }

            // active previous slide
            if(distance > 400) { 
              var prevIndex = currentIndex - 1;
              var $prevMedia = $(this).parent().siblings('.jsc-key-feature-media-item[data-index="' + prevIndex + '"]');
              if($prevMedia.length > 0) {
                var $currentBg = $keyFeatureWrapper.find('.jsc-key-feature-bg[data-index="' + currentIndex + '"]');
                var $prevBg = $keyFeatureWrapper.find('.jsc-key-feature-bg[data-index="' + prevIndex + '"]');
                var $currentContent = $keyFeatureWrapper.find('.jsc-key-feature-content-list .jsc-key-feature-content-item[data-index="' + currentIndex + '"]');
                var $prevContent = $keyFeatureWrapper.find('.jsc-key-feature-content-list .jsc-key-feature-content-item[data-index="' + prevIndex + '"]');

                $prevMedia.find('.jsc-media-box').addClass('active');
                $(this).removeClass('active');
                $prevBg.addClass('active');
                $currentBg.removeClass('active');
                $prevContent.addClass('active');
                $currentContent.removeClass('active');
                updateContentPosition();
              }
            }
          }
        });
      });
    }
  }
}

handleContentScroll2 = () => {
  var $keyFeatureWrapper = $('.jsc-key-feature-wrapper');
  if($keyFeatureWrapper.length > 0) {
    var $mediaList = $keyFeatureWrapper.find('.jsc-img-col .jsc-key-feature-media-item .jsc-media-box');
    $(window).on('scroll', function() {
      var closestIndex = 1;
      var closestDistance = Number.MAX_VALUE;
      $($mediaList).each(function(index) {
        var distance = distanceFromViewportMiddle($(this));
        if (distance < closestDistance) {
          closestIndex = index + 1;
          closestDistance = distance;
        }
      });

      // closestIndex is the next index to change to
      var $mediaItemList = $keyFeatureWrapper.find('.jsc-img-col .jsc-key-feature-media-item');
      var $newActiveMedia = $mediaItemList.filter('[data-index="' + closestIndex + '"]');
      var $bgList = $keyFeatureWrapper.find('.jsc-key-feature-bg');
      var $newBg = $keyFeatureWrapper.find('.jsc-key-feature-bg[data-index="' + closestIndex + '"]');
      var $contentList = $keyFeatureWrapper.find('.jsc-key-feature-content-list .jsc-key-feature-content-item');
      var $newContent = $keyFeatureWrapper.find('.jsc-key-feature-content-list .jsc-key-feature-content-item[data-index="' + closestIndex + '"]');

      $mediaItemList.find('.jsc-media-box').removeClass('active');
      $newActiveMedia.find('.jsc-media-box').addClass('active');
      $bgList.removeClass('active');
      $newBg.addClass('active');
      $contentList.removeClass('active');
      $newContent.addClass('active');
      updateContentPosition();
    });
  }
}

distanceFromViewportMiddle = (el) => {
  const viewportMidY = window.scrollY + window.innerHeight / 2; 
  var docOffsetTop = $(el)[0].getBoundingClientRect().top + window.scrollY;
  const imageMidY = docOffsetTop + $(el).height() / 2; 

  return Math.abs(viewportMidY - imageMidY);
}

initKeyFeatureMobileSlider = () => {
  var $slider = $('.jsc-key-feature-mobile-slider-container');
  if($slider.length > 0) {
    $($slider).flickity({
      cellAlign: 'left',
      wrapAround: false,
      contain: true,
      pageDots: true,
      prevNextButtons: false,
      adaptiveHeight: false
    });

    setTimeout(() => {
      $($slider).find('.jsc-key-feature-mobile-slide').css('height', '100%');
    }, 1000);
  }
}
// end: key feature

// start: hotspot section
activateHotspot = (e) => {
  deactivateHotspot($(e));
  var $hotspot = $(e).parent();
  var $card = $(e).siblings('.jsc-hotspot-card');
  $(e).toggleClass('active');
  $hotspot.toggleClass('active');
  $card.toggleClass('active');
}

deactivateHotspot = (e) => {
  var $otherHotspot = $(e).parent().siblings('.jsc-hotspot');
  var $otherBtnList = $($otherHotspot).find('.jsc-hotspot-trigger-btn');
  var $otherCardList = $($otherHotspot).find('.jsc-hotspot-card');
  $otherHotspot.removeClass('active');
  $otherBtnList.removeClass('active');
  $otherCardList.removeClass('active');
}

updateMobileCardPos = () => {
  var $hotspotWrapper = $('.jsc-hotspots-wrapper');
  if($hotspotWrapper.length > 0 && $(window).width() <= 820) {
    var $cardList = $($hotspotWrapper).find('.jsc-hotspot-card');
    $cardList.each(function() {
      var buttonRect = $(this).siblings('.jsc-hotspot-trigger-btn')[0].getBoundingClientRect();
      var windowWidth = $(window).width();
      var rightOffset = $(this)[0].clientWidth / 2;
      $(this).css('right', 'calc(50% - ' + rightOffset + 'px)');
      var cardRect = $(this)[0].getBoundingClientRect();

      var naturalLeft = buttonRect.left + buttonRect.width / 2 - cardRect.width / 2;
      if(naturalLeft < 10) {
        $(this).css('right', `calc(50% - ${rightOffset - naturalLeft}px - 16px)`);
      }
      else {
        var naturalRight = buttonRect.left + buttonRect.width / 2 + cardRect.width / 2;
        if (naturalRight > windowWidth - 10) {
          $(this).css('right', `calc(50% - ${rightOffset - (naturalRight - windowWidth)}px + 16px)`);
        }
      }
    })
  }
}
// end: hotspot section
// start: shop the look
initCustomProductSlider = () => {
  var $shopTheLook = $('.jsc-shop-the-look-wrapper');
  if($shopTheLook.length > 0 && $(window).width() > 798) {
    $shopTheLook.each(function() {
      var $this = $(this);
      var $sliderNav = $($this).find('.jsc-product-slider-nav');
      if($sliderNav.length > 0) {
        var $prevBtn = $($sliderNav).find('.jsc-product-slider-nav-btn.jsc-nav-previous');
        var $nextBtn = $($sliderNav).find('.jsc-product-slider-nav-btn.jsc-nav-next');
  
        $prevBtn.on('click', function() {
          var $activeSlide = $($this).find('.jsc-product-slide.active');
          var activeIndex = parseInt($activeSlide.attr('data-index'));
          var newIndex = activeIndex - 1;
          var $newSlide = $($activeSlide).siblings('.jsc-product-slide[data-index="' + newIndex + '"]');
  
          if($newSlide.length > 0) {
            $activeSlide.removeClass('active');
            $newSlide.addClass('active');
          }
        });
  
        $nextBtn.on('click', function() {
          var $activeSlide = $($this).find('.jsc-product-slide.active');
          var activeIndex = parseInt($activeSlide.attr('data-index'));
          var newIndex = activeIndex + 1;
          var $newSlide = $($activeSlide).siblings('.jsc-product-slide[data-index="' + newIndex + '"]');
  
          if($newSlide.length > 0) {
            $activeSlide.removeClass('active');
            $newSlide.addClass('active');
          }
        });
      }
    });
  }
}

initMobileProductSlider = () => {
  var $shopTheLook = $('.jsc-shop-the-look-wrapper');
  if($shopTheLook.length > 0 && $(window).width() <= 798) {
    var $slider = $($shopTheLook).find('.jsc-product-slider');
    $($slider).flickity({
      cellAlign: 'left',
      wrapAround: false,
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      adaptiveHeight: false
    });
  }
}
// end: shop the look

//start: side cart drawer
jscOpenCartDrawer = () => {
  $('.jsc-cart-drawer-div').addClass('open-cart-drawer');
  $('.jsc-cart-drawer-overlay').removeClass('d-none');
  $('body').css({
    overflow: 'hidden'
  });
  //start: close drawer when clicked outside
  $('.jsc-cart-drawer-overlay').click(function(){
    jscCloseCartDrawer();
  });
  //end: close drawer when clicked outside
}
jscCloseCartDrawer = () => {
  $('.jsc-cart-drawer-div').removeClass('open-cart-drawer');
  $('.jsc-cart-drawer-overlay').addClass('d-none');
  $('body').css({
    overflow: 'scroll'
  });
}
jscUpdateCartDrawer = (varID,isGwpInCart) => {
  console.log('update cart drawer');
  setTimeout(function(){
    fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      var $cartItems = data.items;
      var $cartDrawerItems = $('.jsc-cart-items-section')

      

      //start: update cart drawer content
        for (var i = 0; i < $cartItems.length; i++) {
          var $itemID = $cartItems[i].id;
          var $itemQty = $cartItems[i].quantity;
          var $itemProdTitle = $cartItems[i].product_title;
          var $itemVarOpt = $cartItems[i].options_with_values;
          var $itemUrl = $cartItems[i].url;
          var $itemImage = $cartItems[i].featured_image.url;
          var $itemImageAlt = $cartItems[i].featured_image.alt;
          var $itemPrice = $cartItems[i].price;
          var $isItemInDrawer = false;
          var $itemKey = $cartItems[i].key;
          //console.log('$itemID',$itemID);
  
          $cartDrawerItems.children().each(function(){
            var $thisID = $(this).attr('data-var-id');
  
            if ($thisID == $itemID) {
              
              $isItemInDrawer = true;
              if (varID == $thisID) { //update the content of matching variant ID
                console.log('update qty of',$itemID);
                $(this).find('.cart-item__quantity-input').attr('value',$itemQty);
                $(this).find('.minus').removeClass('unusable');
              }
            }
            
          });
          //console.log('$isItemInDrawer',$isItemInDrawer,$itemID);
          if ($isItemInDrawer == true) {
            //console.log('update item grid');
            jscOpenCartDrawer();
          } else {
            //if item is not in cart drawer yet, build the grid
            //console.log('build item grid');
            jscCreateCartGrid($itemID,$itemQty,$itemProdTitle,$itemVarOpt,$itemUrl,$itemImage,$itemImageAlt,$itemPrice,isGwpInCart,$itemKey)
          }
        }
      //end: update cart drawer content

      //console.log('isGwpInCart from update drawer',isGwpInCart);
      if (isGwpInCart == true) {
        var freeItemID = parseInt($('.jsc-cart-gift-remove.jsc-promo-1').val());
        console.log('freeItemId',freeItemID);
        $cartDrawerItems.children().each(function(){
          var $thisID = $(this).attr('data-var-id');
          if ($thisID == freeItemID) {
            $(this).remove();
          }
        });
      }

      var _sgMinPrice = parseInt($('.jsc-cart-freedelivery-section .cart-shipping__wrapper').attr('minprice-aud'));
      var _gwpMinPrice = parseInt($('.jsc-cart-freegift-section .cart-shipping__wrapper').attr('minprice-aud'));
      calculateProgress(data.total_price, _sgMinPrice);
      calculateProgressGWP(data.total_price, _gwpMinPrice);

      //start: update cart drawer header
      var $drawerHeader = $('.jsc-cart-drawer-header');
      $('.cart-link').find('.cart-link__count').html(data.item_count);
      $drawerHeader.find('.cart-drawer-qty').html(data.item_count);
      //end: update cart drawer header

      //start: update cart drawer footer
      var $drawerFooter = $('.jsc-cart-drawer-footer');
      var format_CartPrice = Shopify.formatMoney(data.total_price, $('body').data('money'));
      var currency_CartPrice = format_CartPrice.replace('undefined','$');
      $drawerFooter.find('.jsc-cart-drawer-total').html(currency_CartPrice);
      //end: update cart drawer footer
    });
    //document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  },200);
  
}
jscCreateCartGrid = ($itemID,$itemQty,$itemProdTitle,$itemVarOpt,$itemUrl,$itemImage,$itemImageAlt,$itemPrice,isGwpInCart,$itemKey) => {
  //console.log($itemID,$itemQty,$itemProdTitle,$itemVarOpt,$itemUrl,$itemImage,$itemImageAlt,isGwpInCart);
  var format_varPrice = Shopify.formatMoney($itemPrice, $('body').data('money'));
  var currency_varPrice = format_varPrice.replace('undefined','$');
  var $cloneGrid = $('.jsc-cart-items-section').find('.jsc-dummy-cart-line-items.jsc-cart-line-items').first().clone();
  var $getVarDetails = $('.jsc-product-variant-details');
  var $thisMaxQty;

  $getVarDetails.children().each(function(){
    var $thisID = $(this).attr('data-var-id');
    if ($itemID == $thisID) {
      $thisMaxQty = $(this).attr('data-max-qty');
      $cloneGrid.find('.jsc-product-details-input').attr('data-max-qty',$thisMaxQty);
      if ($thisMaxQty <= 1) {
        $cloneGrid.find('.jsc-qty-selector .plus').addClass('unusable');
      }
    }
  });

  $cloneGrid.find('.cart-line-item-img a').attr('href',$itemUrl);
  $cloneGrid.find('.cart-line-item-img img').attr('src',$itemImage);
  $cloneGrid.find('.cart-line-item-img img').attr('alt',$itemImageAlt);
  $cloneGrid.find('.cart-line-item-prod-title a').text($itemProdTitle);
  $cloneGrid.attr('data-var-id',$itemID);
  $cloneGrid.attr('data-key',$itemKey);
  $cloneGrid.attr('data-gwp','false');
  $cloneGrid.find('.cart-line-item-var-title').remove();
  $cloneGrid.find('.jsc-qty-selector input').attr('value',$itemQty);
  $cloneGrid.find('.jsc-qty-selector .quantity-down').addClass('unusable');
  if (isGwpInCart == false) {
    $cloneGrid.find('.jsc-qty-selector .quantity').remove();
    $cloneGrid.find('.jsc-qty-selector').addClass('jsc-cart-drawer-free-gift-label')
    $cloneGrid.find('.jsc-qty-selector').append('<span class="jsc-cart-drawer-free-gift-span">FREE GIFT</span>');
    $cloneGrid.attr('data-gwp','true');
  }
  $cloneGrid.find('.cart-line-item-price .jsc-variant-price .theme-money').text(currency_varPrice);
  //console.log('currency_varPrice',currency_varPrice);
  for (var j = 0; j < $itemVarOpt.length; j++) {
    var $itemVarTitle = $itemVarOpt[j].name + ': ' + $itemVarOpt[j].value;

    $cloneGrid.find('.cart-line-item-prod-var-title').append('<div class="cart-line-item-var-title">' + $itemVarTitle + '</div>');
  }
  $cloneGrid.removeClass('d-none').removeClass('jsc-dummy-cart-line-items');
  //$cloneGrid.appendTo('.jsc-cart-items-section');
  $cloneGrid.insertAfter('.jsc-dummy-cart-line-items.jsc-cart-line-items');
  //setTimeout(function(){
    jscOpenCartDrawer(); //open drawer after grid is created
  //},500);
  
}
//end: side cart drawer

//start: calculate free shipping
calculateProgress = (currentVal, targetVal) => {

  var freeDeliverySection = $('.jsc-cart-freedelivery-section')
  var cartMinText = freeDeliverySection.find('.cart-shipping__wrapper').attr('minprice-aud');
  var cartMinVal = parseInt(cartMinText);
  var progressBar = freeDeliverySection.find('.cart-shippingThreshold__progress');
  var progressNum = freeDeliverySection.find('.cart-shipping__num');
  var progressOuter = freeDeliverySection.find('.cart-shipping__numOuter');
  var successMsg = freeDeliverySection.find('.cart-shipping__success');

  if (freeDeliverySection.length > 0) {
    $.when($.getJSON('/cart.js', function(cart) {
      var _totalPrice = cart.total_price;
      
      if (_totalPrice > 0) {
        freeDeliverySection.removeClass('d-none');
        var calcFreeDeliveryVal = (cartMinVal - _totalPrice) / 100;
        var progressWidth = Math.round(100 * _totalPrice / cartMinVal);
        if (progressWidth >= 100) {
          progressWidth = 100;
        }
        var progressWidthPercent = progressWidth.toString() + '%';
        //console.log('cart Total',_totalPrice,cartMinVal,progressWidth,progressWidthPercent);

        progressBar.each(function(){
          
          $(this).css({
            width: progressWidthPercent
          });
        });

        if (_totalPrice >= cartMinVal) {
          console.log('free delivery');
          progressOuter.hide();
          successMsg.show();
        } else {
          console.log('still short from free delivery',calcFreeDeliveryVal);
          progressNum.text(calcFreeDeliveryVal);
          progressOuter.show();
          successMsg.hide();
        }
      }
      else{
        //console.log('cart Total',_totalPrice);
        freeDeliverySection.addClass('d-none');
      }
      
    })).then(function() {
      
    });
  }
};
//end: calculate free shipping
fetch('/cart.js')
.then(response => response.json())
.then(data => {
  var _sgMinPrice = parseInt($('.jsc-cart-freedelivery-section .cart-shipping__wrapper').attr('minprice-aud'));
  var _gwpMinPrice = parseInt($('.jsc-cart-freegift-section .cart-shipping__wrapper').attr('minprice-aud'));
  //calculateProgress(data.total_price, _sgMinPrice);
  //calculateProgressGWP(data.total_price, _gwpMinPrice);
});
//end: calculate free shipping

//start: cart drawer qty selector
jscMinusItemCartDrawer = (e) => {
  var $input = $(e).parent().find('input');
  var count = parseInt($input.val()) - 1;
  var $maxQty = parseInt($(e).parents('.jsc-cart-line-items').find('.jsc-product-details-input').attr('data-max-qty'));
  var $thisPlus = $(e).parent().find('.plus');
  count = count < 1 ? 1 : count;
  //$input.val(count);
  $input.attr('value',count);
  $input.change();

  var $vid = $(e).parents('.jsc-cart-line-items').attr('data-var-id');
  if (count >= 1) {
    //console.log('enable minus');
    $(e).removeClass('unusable');
    cartJSUpdateQuery($vid, count, {}, true);
    
  } 
  if (count == 1) {
    //console.log('disable minus');
    $(e).addClass('unusable');
  }
  
  jscUpdateCartDrawer();
  if ($input.val() < $maxQty ) {
    $thisPlus.removeClass('unusable'); // allow to add more product
  }
}
jscPlusItemCartDrawer = (e) => {
  var $input = $(e).parent().find('input');
  var $thisMinus = $(e).parent().find('.minus');
  var $maxQty = parseInt($(e).parents('.jsc-cart-line-items').find('.jsc-product-details-input').attr('data-max-qty'));
  var $inputValueInt = parseInt($input.val());

  //console.log('current value',$inputValueInt,'$maxQty',$maxQty);
  if ($inputValueInt < $maxQty ) {
    //console.log('allow add');
    var count = parseInt($input.val()) + 1;
    //console.log('added',count);
    $input.attr('value',count);
    //$input.change();
    $thisMinus.removeClass('unusable'); // allow to add more product

    var $vid = $(e).parents('.jsc-cart-line-items').attr('data-var-id');
    
    cartJSUpdateQuery($vid, count, {}, true);
    jscUpdateCartDrawer();
    if ($input.val() >= $maxQty) {
      $(e).addClass('unusable'); // dont allow to add more product
      //console.log('dont allow add');
    }
  } 
}
jscRemoveItemCartDrawer = (e) => {
  var $vid = $(e).parents('.jsc-cart-line-items').attr('data-var-id');
  cartJSUpdateQuery($vid, 0, {}, true);
  $(e).parents('.jsc-cart-line-items').remove();

  var $isGwp = $(e).parents('.jsc-cart-line-items').attr('data-gwp');
  if ($isGwp == 'true') {
    sessionStorage.setItem("FreeGift", "Remove");
  }

  setTimeout(function(){
    jscUpdateCartDrawer('',true);
  },500);

}
//end: side cart drawer

//start: calculate free gift GWP progress bar
calculateProgressGWP = (currentVal, targetVal) => {
  var freeGiftSection = $('.jsc-cart-freegift-section');
  var cartMinText = freeGiftSection.find('.cart-shipping__wrapper').attr('minprice-aud');
  var cartMinVal = parseInt(cartMinText);
  var progressBar = freeGiftSection.find('.cart-shippingThreshold__progress');
  var progressNum = freeGiftSection.find('.cart-shipping__num');
  var progressOuter = freeGiftSection.find('.cart-shipping__numOuter');
  var successMsg = freeGiftSection.find('.cart-shipping__success');
  var freeItemId = freeGiftSection.find('.cart-shipping__wrapper').attr('data-item-id');
  var isGwpInCart = false;

  if (freeGiftSection.length > 0) {
    $.when($.getJSON('/cart.js', function(cart) {
      var _totalPrice = cart.total_price;
      var $cartItems = cart.items;

      for (var i = 0; i < $cartItems.length; i++) {
        var $itemID = $cartItems[i].id;
        var $itemGwpProp = $cartItems[i].properties['_Cart_GWP'];
        var $itemGwpPropPromo = $cartItems[i].properties['_Cart_Gift'];

        if (freeItemId == $itemID && $itemGwpProp == 'Free Gift' && $itemGwpPropPromo == 1) {
          isGwpInCart = true;
          
        }
      }
      console.log('isGwpInCart',isGwpInCart);
      
      if (_totalPrice > 0) {
        freeGiftSection.removeClass('d-none');
        var calcFreeDeliveryVal = (cartMinVal - _totalPrice) / 100;
        var progressWidth = Math.round(100 * _totalPrice / cartMinVal);
        if (progressWidth >= 100) {
          progressWidth = 100;
        }
        var progressWidthPercent = progressWidth.toString() + '%';
        //console.log('cart Total',_totalPrice,cartMinVal,progressWidth,progressWidthPercent);

        progressBar.each(function(){
          
          $(this).css({
            width: progressWidthPercent
          });
        });

        if (_totalPrice >= cartMinVal) {
          console.log('free gift');
          progressOuter.hide();
          successMsg.show();
          if (isGwpInCart == false) {
            $('.jsc-cart-items-section').append('<input type="hidden" value="'+ freeItemId +'" class="jsc-cart-gift" data-promo="1">');
            cartGift();
            jscUpdateCartDrawer(freeItemId,isGwpInCart);
          } else {
            $('.jsc-cart-items-section .jsc-cart-gift').remove();
          }
          
        } else {
          console.log('still short from free gift',calcFreeDeliveryVal);
          progressNum.text(calcFreeDeliveryVal);
          progressOuter.show();
          successMsg.hide();
          if (isGwpInCart == true) {
            $('.jsc-cart-items-section').append('<input type="hidden" value="'+ freeItemId +'" class="jsc-cart-gift-remove jsc-promo-1">');
            //isGwpInCart = false;
            cartGift();
            jscUpdateCartDrawer(freeItemId,isGwpInCart);
          }
        }
      }
      else{
        //console.log('cart Total',_totalPrice);
        freeGiftSection.addClass('d-none');
      }
      
    })).then(function() {
    });
  }
};
jscUpdateShippingAndGWPbar = () => {
  setTimeout(function(){
    calculateProgress();
    calculateProgressGWP();
  },500);
}
//end: calculate free gift GWP progress bar

//start: hide size variant with variant metafield
onloadHideSizeVariant = () => {
  var $current_id = $('.price-descriptors').find('form [name="id"]').val();
  var $variant_info = $('.jsc-variant-details').find('input');
  var $variant_button = $('.options--size').find('li');
  var $main_button = $('.buy-buttons-row'); // ATC or notify me button

  $variant_info.each(function(){
    var $thisID = $(this).attr('data-var-id');
    var $thisQty = $(this).attr('data-var-stock');
    var $thisHide = $(this).attr('data-var-hide');
    var $thisSize = $(this).attr('data-var-size');
    var $thisAvail = $(this).attr('data-var-avail');

    if ($thisHide == 'true') {
      
      //console.log('$thisID is hidden',$thisID);
      $variant_button.each(function(){
        var $btn_size = $(this).find('a').attr('data-value');
        if ($btn_size == $thisSize && $thisHide == 'true') {
          //console.log('$this button is hidden',$thisID);
          $(this).css({ 'display': 'none'});
          // $main_button.css({ 'opacity': '0'});
        }
      });
    }
    
  })
  //console.log('$current_id',$current_id);
  // console.log('test');
}
//end: hide size variant with variant metafield

//start: zoom image when click on the zoom icon
zoomImagePdp = (e) => {
  //console.log('click zoom');
  
  if ($(window).width() > 799) {
    var $imgGallery = $(e).siblings('.jsc-product-gallery__main').find('.product-gallery__image');
    var $imgFirst = $imgGallery.first(); //get only the first image for desktop

  } else {
    var $imgFirst = $(e).siblings('.jsc-product-gallery__main').find('.product-gallery__image.is-selected'); // get the active image for mobile

  }
  //console.log('$imgFirst',$imgFirst);

  $imgFirst.find('.product-media-wrapper').click(); //click only the first image for desktop. click on the active image for mobile
 
}
//end: zoom image when click on the zoom icon

//start: initiate flickity for image gallery in pdp
initFlickityImageGallery = () => {
  var $newGallery = $('.jsc-product-gallery__main').length;

  if ($(window).width() < 480) {
    if ($newGallery > 0) {
      //console.log('init flickity in mobile');
      $('.jsc-product-gallery__main').flickity({
        // options
        prevNextButtons : true,
        pageDots : false,
        wrapAround : true,
        contain: true,
        cellAlign: 'left',
        draggable: true,
        imagesLoaded : true,
        on: {
          ready: function() {
            $(this.element).addClass('jsc-flickity-initiated');
          }
        }
      });
    }
  }
  
}
//end: initiate flickity for image gallery in pdp